import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { SignatorydetailsService } from '../../main-layout/signatorydetails/signatorydetails.service';
import { Signatory } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { BaseClass } from '../../utility/baseClass';

@Component({
  selector: 'app-signatorymodal',
  templateUrl: './signatorymodal.component.html',
  styleUrls: ['./signatorymodal.component.css']
})
export class SignatorymodalComponent  extends BaseClass implements OnInit{
  tableData: any[] = []; // Initialize with an empty array
  signatoryList = [];
  userlist = [];
  userdata = [];
  nameReadonly = false;
  emailReadonly = false;
  details: any;
  signatorys: any;
  signatoryarray: Array<Signatory>;
  saveTitle = 'Add';
  public SignatoryForm: FormGroup;
  onlyView: boolean = false
  isEdit: boolean = false;
  isSelected: boolean = false;
  Signatorydetails: any = {};
  CSRFToken = "";
  UsertypeFlag = [
    { 'labelname': 'Internal', 'value': 'I' },
    { 'labelname': 'External', 'value': 'E' }
  ];

  public validation_message = {
    'user': [''],
    'name': [
      { type: 'required', message: 'User Name is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric is allowed' }
    ],
    'email': [
      { type: 'required', message: 'Email is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'EMAIL', message: "Email format is incorrect" },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric is allowed' }
    ],
    'mobile': [
      { type: 'ONLYNUMERIC', message: 'Only numeric is allowed' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
  }

  constructor(
    public signatoryService: SignatorydetailsService,
    private fb: FormBuilder,
    public utilityservice: Utilityservice,
    private el: ElementRef,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig, private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    this.gettoken();
    const dataFromParent = this.config.data;
    if (dataFromParent?.title == 'Modify Signatory Data') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.Signatorydetails = dataFromParent.datas
    }
  }

  gettoken() {
    this.CSRFToken = '';
    this.spinnerservice.show()
    this.signatoryService.getCSRFtoken().subscribe(res => {
      this.spinnerservice.hide();
      this.CSRFToken = res.csrf;
    }, error => {
      this.spinnerservice.hide();
      Swal.fire(error.error.message, '', 'error');
    });
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getuserlist();
    this.getData();
  }

  formInitiliaze() {
    this.SignatoryForm = this.fb.group({
      user: [''],
      name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      email: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.EMAIL),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      mobile: ['', Validators.compose([
        Validators.maxLength(11),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      ])]
    })
  }

  getData() {
    this.patchValueForms(this.Signatorydetails[0])
  }

  patchValueForms(data) {
    if (this.isEdit) {
      this.SignatoryForm.patchValue({ 'rid': data.rid });
      this.SignatoryForm.patchValue({ 'user': data.userid });
      this.SignatoryForm.patchValue({ 'name': data.name });
      this.SignatoryForm.patchValue({ 'email': data.email });
      this.SignatoryForm.patchValue({ 'mobile': data.mobno });
    }
  }

  getuserlist() {
    this.signatoryService.getuserlist().subscribe(res => {
      this.userlist = res;
    })
  }


  dismiss() {
    Swal.fire({
      title: "Are you sure you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  // Add New SIGNATORY Record
  tempsignatory: any;
  add() {
    if (this.SignatoryForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill up all the mandatory/required fields and then Save!',
        customClass: { icon: 'custom-skyblue-icon' },
        willClose: () => {
          this.validateAllFormFields(this.SignatoryForm, this.el);
          setTimeout(() => {
            const firstInvalidControl = document.querySelector('.ng-invalid') as HTMLElement | null;
            if (firstInvalidControl) {
              const focusable = firstInvalidControl.querySelector<HTMLElement>(
                'input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (focusable) { focusable.focus(); }
              else {
                firstInvalidControl.tabIndex = -1;
                firstInvalidControl.focus();
              }
            }
          }, 10);
        }
      });
    }
    else {
      if (this.saveTitle == 'Modify') {
        this.modifySignatory(this.SignatoryForm.value)
      }
      else {
        const datapayload = {
          name: this.SignatoryForm.get('name').value,
          email: this.SignatoryForm.get('email').value,
          mobile: this.SignatoryForm.get('mobile').value,
          csrftoken: this.CSRFToken

        }
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
            this.signatoryService.add(datapayload).subscribe((data) => {
              this.tempsignatory = data;
              if (this.tempsignatory.response == 'exists') {
                Swal.fire("Signatory name already exists!", "", "error").then(() => {
                });
              }
              else {
                Swal.fire("The Signatory data is added successfully!", "", "success").then(() => {
                  this.ref.close()
                });
              }
            },
              error => {
                if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.error.error,
                  footer: "error status is :" + ' ' + error.status
                });}
              });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info")
            this.ref.close
          }
        });
      }
    }
  }

  //Modify SIGNATORY
  tempSignatoryUpdate: any;
  modifySignatory(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          data.rid = this.Signatorydetails[0].rid
          data.name = this.SignatoryForm.get('name').value;
          data.mobile = this.SignatoryForm.get('mobile').value;
          data.email = this.SignatoryForm.get('email').value;
          data.csrftoken = this.CSRFToken;


          this.signatoryService.modify(data).subscribe((data) => {
            this.tempsignatory = data;
            if (this.tempsignatory.response == 'exists') {
              Swal.fire("Signatory name already exists!", "", "error").then(() => {
                this.ref.close()
              });
            }
            else {
              Swal.fire("Signatory Data is modified successfully!", "", "success").then(() => { this.ref.close() });
            }
          },



            error => {
              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({ icon: "error", title: "Oops...", text: error.error.error, footer: "error status is :" + ' ' + error.status });
                  }
            });
          Swal.fire("The SIGNATORY Data is modified successfully!", "", "success").then(() => {
            this.ref.close()
          });
        }
        else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
          this.ref.close
        }
      });

  }

  clearSearch(dropdown: any) {
    dropdown.resetFilter();
  }
  onuserchange(event: any) {
    this.signatoryService.getuserdata(event.value).subscribe(res => {
      this.details = res[0];
      if (this.details.name && this.details.name.trim() !== '') { this.isSelected = true; } else { this.isSelected = false; }
      this.SignatoryForm.patchValue({ 'name': this.details.name });
      this.SignatoryForm.patchValue({ 'email': this.details.emailaddr });

    }, error => {
      Swal.fire(error.error.message, '', 'error');
    })
  }
}
